// NavigationBridge.tsx ou .jsx
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export function NavigationBridge() {
    const history = useHistory();

    useEffect(() => {
        // expõe navegação global para o Blazor
        window.reactNavigate = url => {
            history.push(url);
        };
    }, [history]);

    return null;
}